import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingAutocompleteCnpjTrue, loadingAutocompleteCnpjFalse } from '../../store/reducers/utils';

const AutocompleteMap = ({ value, setPosition, formState, setFormState, setSemNumero, setCidadePesquisa, handleCidadesChange, estados, ...props }) => {

    const [autocompleteService, setAutocompleteService] = useState(null);
    const [predictions, setPredictions] = useState([]);
    const [autocompleteOptions, setAutocompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [finalValue, setFinalValue] = useState(null);

    const autocompleteForms = (addressComponents) => {
        const placeInfo = {
            complemento: '',
            bairro: '',
            estado: '',
            cidade: '',
            cep: '',
            numero: '',
        };

        addressComponents.forEach(component => {
            switch (component.types[0]) {
                case 'subpremise':
                    placeInfo.complemento = component.long_name;
                    break;
                case ('political'):
                    placeInfo.bairro = component.long_name;
                    break;
                case 'administrative_area_level_1':
                    placeInfo.estado = component.long_name;
                    break;
                case 'administrative_area_level_2':
                    placeInfo.cidade = component.long_name;
                    break;
                case 'postal_code':
                    placeInfo.cep = component.long_name;
                    break;
                case 'street_number':
                    placeInfo.numero = component.long_name;
                    break;
                default:
                    // Se houver outros tipos que você precisa lidar, adicione aqui
                    break;
            }
        });

        const estado = estados.find((estado) => estado.estadoNome === placeInfo.estado)
        const estadoID = estado ? estado.estadoID : ''

        setFormState({
            ...formState,
            complemento: placeInfo.complemento || '',
            bairro: placeInfo.bairro || '',
            estado: estadoID,
            cidade: '',
            cep: placeInfo.cep || '',
            numero: placeInfo.numero || '',
        })

        setSemNumero(() => {
            if (placeInfo.numero === undefined) {
                return false;
            } else {
                // Remove todos os caracteres não numéricos da string de número
                const apenasNumeros = placeInfo.numero.replace(/\D/g, '');
                // Verifica se a string contém algum número
                const validation = !/\d/.test(apenasNumeros)
                validation
                    ? setFormState(prevState => ({ ...prevState, numero: 'S/N' }))
                    : setFormState(prevState => ({ ...prevState, numero: placeInfo.numero }));
                return validation;
            }
        })

        handleCidadesChange(estadoID);
        setCidadePesquisa(placeInfo.cidade)
    }

    const getLatLng = async (placeDescription) => {
        const apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(placeDescription) + '&key=AIzaSyDi_LKzscOj1wkn9GeYROet6_dfGfz91Kk';

        try {
            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data.status === 'OK' && data.results.length > 0) {
                // Puxa as informações e prenche os campos
                autocompleteForms(data.results[0].address_components)

                // Puxa localização e retorna nova posição do Marker e do Mapa
                const location = data.results[0].geometry.location;
                const finalLocation = {
                    latitude: location.lat,
                    longitude: location.lng,
                }
                return finalLocation;
            } else {
                console.log("Não foi possível obter as coordenadas para", placeDescription);
                return null;
            }
        } catch (error) {
            console.error("Ocorreu um erro ao obter as coordenadas:", error);
            return null;
        }
    }

    useEffect(() => {
        // Verificar se a API do Google Maps já está carregada
        if (window.google && window.google.maps) {
            setAutocompleteService(new window.google.maps.places.AutocompleteService());
        }
    }, []);

    useEffect(() => {
        if (predictions.length > 0) {
            // armazena as opções de escolha do autocomplete 
            setAutocompleteOptions(predictions.map((prediction, index) => ({ label: prediction.description, id: index })));
        } else {
            {
                // Reseta as opções para um array vazio
                setAutocompleteOptions([]);
            }
        }
    }, [predictions])

    const handleInputChange = (event, value) => {
        // Fazer uma solicitação ao serviço de Autocomplete para obter previsões
        if (autocompleteService) {
            autocompleteService.getPlacePredictions(
                {
                    input: value,
                    language: 'pt-BR',
                    // types: ['address', 'establishment'],
                    componentRestrictions: { country: 'BR' },
                },
                (predictions, status) => {
                    if (status === 'OK') {
                        // armazena a resposta da API
                        setPredictions(predictions);
                    } else {
                        // Reseta as opções para um array vazio
                        setPredictions([]);
                    }
                });
        }

        if (value === '') {
            setPredictions([]);
        }
        // Atualiza o estado finalValue para o valor de entrada atual
        setFinalValue(value);
        setFormState((prevState) => ({
            ...prevState,
            endereco: value,
        }))
    };

    useEffect(() => {
        const fetchData = async () => {
            if (predictions.filter(prediction => prediction.description === finalValue).length > 0) {
                try {
                    const finalLocation = await getLatLng(finalValue);
                    if (finalLocation !== null) {
                        setPosition(finalLocation);
                    }
                } catch (error) {
                    console.error("Erro ao obter coordenadas:", error);
                }
            }
        };
        fetchData();

        if (finalValue !== formState.endereco) {
            setFormState((prevState) => ({
                ...prevState,
                endereco: finalValue === null ? '' : finalValue,
            }))
        }
    }, [finalValue])

    useEffect(() => {
        setFinalValue(value)
    }, [value])

    return (
        <Autocomplete
            freeSolo
            options={autocompleteOptions}
            onChange={(event, value) => {
                if (value === null) {
                    setFinalValue('');
                } else {
                    setFinalValue(value.label);
                }
            }}
            onInputChange={handleInputChange}
            value={value}
            {...props}
            renderInput={
                (params) => (
                    <TextField
                        {...params}
                        label="Endereço"
                        name="endereco"
                        onBlur={() => {
                            setFormState({
                                ...formState,
                                enderecoTocado: true,
                            });
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            )
                        }}
                    />
                )
            }
        />
    );
}

export default AutocompleteMap
